import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import CustomPagination from '../../components/CustomPagination'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { useIncentive } from '../../hooks/Features/useIncentive'
import { formatNumber, getUniqueValues } from '../../shared/constants'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'

export default function QuaterlyVsActualAchievementReport() {

    const { getQuaterlyVsActualAchievementReport, loading, paginate, incentives, getPdfCsvData, downloadLoading, pdfCsvData, downloadKeys, positions, managers } = useIncentive()

    const [searchQuery, setSearchQuery] = useState('')

    const startDate = new Date()
    startDate.setDate(1)
    startDate.setHours(0, 0, 0)
    startDate.setMonth(1);
    const [from, setFrom] = useState(startDate.toISOString())
    const [to, setTo] = useState(new Date().toISOString())

    const [page, setPage] = React.useState(1)

    const [filterParams, setFilterParams] = useState({ storeName: null, firstName: 1, managerRank: '', managerId: '' })

    const noOfPages = paginate.totalPage;

    useEffect(() => {
        getQuaterlyVsActualAchievementReport({ from, to, ...filterParams, searchQuery, page })
    }, [from, to, filterParams, searchQuery, page])

    useEffect(() => {
        getPdfCsvData(downloadKeys.QUATERLY_VS_ACTUAL_ACHIEVEMENT_REPORT, { from, to })
    }, [from, to])

    const handleChange = (event, value) => {
        setPage(value)
    }

    const tableHeading = ['Store', ...positions.filter((item) => item && item.rank === 6).map(item => item.positionName), 'Q1', 'Q2', 'Q3', 'Q4', 'Total'];
    const subHeading = ['Target', 'Actual', '%'];

    return (
        <Layout
            heading="Quarterly Vs Actual Achievement Report"
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            selectedFrom={from}
            setSelectedFrom={setFrom}
            selectedTo={to}
            setSelectedTo={setTo}
            headers={pdfCsvData.headings}
            data={pdfCsvData.headingValues}
            filename="quaterly-vs-actual-achievement-report"
            downloadLoading={downloadLoading}
            filterRank={filterParams.managerRank}
            setFilterRank={(val) => setFilterParams({ ...filterParams, managerRank: val, managerId: '' })}
            filterName={filterParams.managerId}
            setFilterName={(val) => setFilterParams({ ...filterParams, managerId: val })}
            filterNamesOptions={managers && managers[`rank${filterParams.managerRank}`] ? managers[`rank${filterParams.managerRank}`] : []}
            filterRankOptions={positions ? positions.map(item => ({ value: item.rank, name: item.positionName })) : []}
        >
            <CustomTable>
                <CustomTableHeading
                    setFilterParams={setFilterParams}
                    filterParams={filterParams}
                    heading={tableHeading}
                    columnSpan={{ Q1: 3, Q2: 3, Q3: 3, Q4: 3, Total: 3 }}
                />
                <CustomTableRow>
                    <TableCell colSpan={6}></TableCell>
                    {[0, 1, 2, 3, 4].map((val) => {
                        return subHeading.map((item) => {
                            return <TableCell style={{ borderLeft: item === 'Target' ? '1px solid black' : 'none' }}>{item}</TableCell>
                        })
                    })}
                    <TableCell></TableCell>
                </CustomTableRow>
                <TableBody>
                    {!loading &&
                        incentives.length > 0 &&
                        incentives.map((item, index) => {
                            return item.allTargetOfStore.map((target) => {
                                return (
                                    <CustomTableRow key={index}>
                                        <TableCell> {item.storeName} </TableCell>
                                        <TableCell> {item.rank6Name} </TableCell>
                                        {target.targetDuration.map((dur) => {
                                            return (
                                                <React.Fragment>
                                                    <TableCell>{formatNumber(dur.targetAmount)}</TableCell>
                                                    <TableCell>{formatNumber(dur.totalSaleAmount)}</TableCell>
                                                    <TableCell>{(dur.totalSaleAmount * 100 / dur.targetAmount).toFixed()}</TableCell>
                                                </React.Fragment>
                                            )
                                        })}
                                        <TableCell>{formatNumber(target.total.targetAmount)}</TableCell>
                                        <TableCell>{formatNumber(target.total.totalSaleAmount)}</TableCell>
                                        <TableCell>{(target.total.totalSaleAmount * 100 / target.total.targetAmount).toFixed()}</TableCell>
                                    </CustomTableRow>
                                )
                            })
                        })}
                </TableBody>
            </CustomTable>

            {!loading && incentives.length > 0 && (
                <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
            )}

            {!loading && !incentives.length && <NoDataFound text="No Incentive Found" />}

            {loading && <Loader />}
        </Layout>
    )
}